import { createStore, compose, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
import rootReducer from './reducers'
import rootSaga from './saga'

const countries = require('../data/data_countries.json')
const indicators = require('../data/data_indicators.json')
const tfaMeta = require('../data/data_tfa_articles_meta.json')
const meta = require('../data/data_meta.json')
const countriesContinents = require('../data/countries_continents.json')

const sagaMiddleware = createSagaMiddleware()
const store = createStore(
  rootReducer,
  { countries, indicators, meta, tfaMeta, countriesContinents },
  compose(
    applyMiddleware(sagaMiddleware),
    window.devToolsExtension ? window.devToolsExtension() : f => f,
  ),
)
sagaMiddleware.run(rootSaga)

export default store



// WEBPACK FOOTER //
// ./src/state/index.js